export const SET_WELCOME = "SET_WELCOME";
export const SET_MARCA = "SET_MARCA";